<template lang="pug">
	b-tabs(:class="`tab-${Layout.settingsTabName}`" v-if="Project.isSelectedProjectLoaded()" ref="tabsElement")
		b-tab(v-if="Project.SelectedProject.type === 'playable'" v-on:click="tabClick('mraid-sdk')")
			template(slot="title")
				i.main-tab.fa.fa-tasks(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Mraid SDK'}")
			.p-3
				h6 Mraid SDK test
				div
					small.text-muted Here you can check main Mraid SDK actions. As a rule, they should all be green after you played and clicked on creative CTA button.
				MraidSDK
</template>

<script>

	import Screen 						from './../../mixins/screen';

	import MraidSDK						from "./TabContent/MraidSDK";

	import { Publisher } 				from './../../services/Publisher';
	import { Project } 					from './../../services/Project';
	import { Version } 					from './../../services/Version';
	import { Settings } 				from './../../services/Settings';
	import { Asset } 					from './../../services/Asset';

	export default {
		name: 'TestingContent',
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Workspace Changed", "Selected Version Changed", "Selected Project Fully Loaded", "Update Settings Content", "Selected Version Setting Changed", "Selected Version Tracking Providers Changed"],
			events: {
				"Settings Tab Changed": function() {

					this.$forceUpdate();

					this.$nextTick(() => {

						Broadcast.call("Settings Tab Changed Next Tick");

					});

				},
				"Settings Tab Changed Next Tick,Aside State Opened": function() {

					if (this.$refs.tabsElement) {

						let tabContent = this.$refs.tabsElement.$el.querySelector('.tab-content');

						tabContent.removeEventListener('scroll', this.dispatchScrollEvent);
						tabContent.addEventListener('scroll', this.dispatchScrollEvent);

					}

				}
			}
		},
		components: {
			MraidSDK
		},
		data() {

			this.Project = Project;

			this.settings = {};

			return {
				showed: true,
				bannerTab: 'loading'
			};

		},
		created() {

			this.collectData();

		},
		methods: {
			collectData() {

				if (!Publisher.SelectedPublisher || !Version.SelectedVersion) return;

				if (!Project.isSelectedProjectLoaded()) return;

				let settings = Settings.getVersionSettings(Version.SelectedVersion, false, Project.SelectedProject.type === 'end-card');

				//Сортируем все настройки в нужном порядке
				this.settings = _.orderBy(_.values(settings), o => {

					if (o["section_priority"]) return o["section_priority"];

					return 9999;

				});

			},
			isBannerAvailable() {

				return Project.SelectedProject && Project.SelectedProject.Scripts && Project.SelectedProject.Scripts["mainFiles"] && _.includes(Project.SelectedProject.Scripts["mainFiles"], "App/Screens/Banner.js")
					&& _.includes(Project.SelectedProject.Scripts["mainFiles"], "App/Libs/Pixi.Classes/Screen.Dom.js");

			},
			isEndCardAvailable() {

				return Project.SelectedProject && Project.SelectedProject.Scripts && Project.SelectedProject.Scripts["mainFiles"] && _.includes(Project.SelectedProject.Scripts["mainFiles"], "App/Screens/EndCard.js")
					&& _.includes(Project.SelectedProject.Scripts["mainFiles"], "App/Libs/Pixi.Classes/Screen.Dom.js");

			},
            isEmitterAvailable(setting) {

				if (setting.codename !== 'particles-quality') return true;
                return Project.SelectedProject && Project.SelectedProject.Scripts && Project.SelectedProject.Scripts["mainFiles"]
                    && _.includes(Project.SelectedProject.Scripts["mainFiles"], "App/Libs/Pixi.Classes/Screen.Emitter.js");

            },
            isSoundsAvailable(setting) {

                if (setting.codename.indexOf('sounds') < 0) return true;

                const assets =  Asset.getVersionAssets(Version.SelectedVersion);

                return !!_.find(assets, asset => asset.type === 'sound');

            },
			isLocalizationAvailable() {

				return Settings.getSettingProps("locale");

			},
            isCallToActionAvailable() {

                return Project.SelectedProject && Project.SelectedProject.Scripts && Project.SelectedProject.Scripts["mainFiles"] && _.includes(Project.SelectedProject.Scripts["mainFiles"], "App/Screens/CallToAction.js")
                    && _.includes(Project.SelectedProject.Scripts["mainFiles"], "App/Libs/Pixi.Classes/Game.Pixi.js");

            },
			setBannerTab(banner_tab) {

				console.log(banner_tab);

				this.bannerTab = banner_tab;

			},
			tabClick(tabName) {

				Layout.setSettingsTab(tabName);

			},
			// Позволяет устанавливать связи между настройками, отключать одни в зависимости от других
			isSettingAvailable(setting, settings) {

				const settingsHandler = {
                    '^end-card-bg-lights-.+$': () => {

                        const styles = Settings.getSettingValue(`end-card-bg-lights-styles`);

                        return styles && styles.display !== 'none';

                    },
                    '^end-card-logo-.+$': () => {

                        const styles = Settings.getSettingValue(`end-card-logo-styles`);

                        return styles && styles.display !== 'none';

                    },
                    '^end-card-text-(\\d+)-text$': (matches) => {

                        const id = matches[1];

                        const styles = Settings.getSettingValue(`end-card-text-${id}-styles`);

                        return styles && styles.display !== 'none';

                    },
                    '^end-card-try-again-button-.+$': () => {

                        const styles = Settings.getSettingValue(`end-card-try-again-button-styles`);

                        return styles && styles.display !== 'none';

                    },
                    '^end-card-comment-.+$': () => {

                        const styles = Settings.getSettingValue(`end-card-comment-styles`);

                        return styles && styles.display !== 'none';

                    },
					'^(.+)-banner-comment-.+$': (matches) => {

						const prefix = matches[1];

						const styles = Settings.getSettingValue(`${prefix}-banner-comment-styles`);

						return styles && styles.display !== 'none';

					},
					'^(.+)-banner-description-text$': (matches) => {

						const prefix = matches[1];

						const styles = Settings.getSettingValue(`${prefix}-banner-description-styles`);

						return styles && styles.display !== 'none';

					},
					'^(.+)-banner-button-.+': (matches) => {

						const prefix = matches[1];

						const styles = Settings.getSettingValue(`${prefix}-banner-button-styles`);

						return styles && styles.display !== 'none';

					},
					'^(.+)-banner-rating.*': (matches) => {

						const prefix = matches[1];

						const styles = Settings.getSettingValue(`${prefix}-banner-rating-styles`);

						return styles && styles.display !== 'none';

					},
					'^(.+)-banner-cta-text-(\\d+)-text$': (matches) => {

						const prefix = matches[1];
						const id = matches[2];

						const styles = Settings.getSettingValue(`${prefix}-banner-cta-text-${id}-styles`);

						return styles && styles.display !== 'none';

					}
				};

				const handlerName = Object.keys(settingsHandler).find(key => setting.codename.match(new RegExp(key)));

				if (settingsHandler[handlerName]) return settingsHandler[handlerName](setting.codename.match(new RegExp(handlerName)));

				return true;

			},

			isSeparatorNeeded(settingIndex) {

				let setting = this.settings[settingIndex];
				let prevSetting = this.settings[settingIndex - 1];
				let nextSetting = this.settings[settingIndex + 1];

				if (!setting) return false;

				//В самом начале отделяющая линия не нужна
				if (!prevSetting) return false;

				let settingCodenames = (setting["codename"] || setting["name"] || '').split('-');
				let prevSettingCodenames = (prevSetting["codename"] || prevSetting["name"] || '').split('-');

				if (settingCodenames[0] === prevSettingCodenames[0]) return false;

				return true;

			},

			getGroupedSettings(section) {

				let result = [];

				_.each(this.settings, setting => {

					if (setting["section"] === section) {

						if (setting.options.separator || !result[result.length-1]) result.push([]);

						result[result.length-1].push(setting);

					}

				});

				return result;

			},

			isHidden(setting) {

				if (setting.options.isHidden) return true;

				if (setting.options.dependency && setting.options.dependency['method'] === 'display:none') {

					if (("settingValue" in setting.options.dependency)) return Settings.getSettingValue(setting.options.dependency["settingName"]) !== setting.options.dependency["settingValue"];
					else if (("innerPropertyName" in setting.options.dependency)) return _.get(Settings.getSettingValue(setting.options.dependency["settingName"]), setting.options.dependency["innerPropertyName"]) !== setting.options.dependency["innerPropertyValue"];

				}

				return false;

			},

			dispatchScrollEvent() {

				Broadcast.call("Settings Scroll");

			}
		},

		mounted() {

		}
	}
</script>

<style lang="sass">

	aside.aside-menu
		background-color: #3a4149
		border-left: 1px solid #23282c
		color: #f3f4f5
		width: 390px

		.aside-settings-group
			padding: 1rem !important
			border-top: 1px solid #23282c
			border-left: 1px solid transparent

			&.highlighted
				background-color: transparent

			&.group-0
				border-left-color: transparent

			&.group-1
				border-left-color: rgba(77, 189, 116, 0.5)

			&.group-2
				border-left-color: transparent

			&.group-3
				border-left-color: rgba(255, 193, 7, 0.5)

			&.group-4
				border-left-color: transparent

			&.group-5
				border-left-color: rgba(248, 108, 107, 0.5)

			&.group-6
				border-left-color: transparent

			&.group-7
				border-left-color: rgba(141, 96, 223, 0.5)

			&.group-8
				border-left-color: transparent

			&.group-9
				border-left-color: rgba(232, 62, 140, 0.5)

			&.group-10
				border-left-color: transparent

			&.group-11
				border-left-color: rgba(32, 201, 151, 0.5)

			&:empty
				display: none

			.settings-control > .clearfix.mt-4.control-box
				margin-top: 0 !important

			hr
				display: none

			.aside-setting
				margin-bottom: 1rem

				&:last-child
					margin-bottom: 0

		.switch-slider
			background-color: #343b41
			border: 1px solid #23282c

		.nav-tabs
			font-size: 0.875rem

			.nav-link
				color: #f3f4f5

			.nav-item.show .nav-link, .nav-link.active
				color: #f3f4f5
				background-color: #343b41
				border-color: #23282c #23282c #23282c

			.nav-link.active
				color: #20a8d8
				border-right-color: #23282c
				border-left-color: #23282c

			.nav-link:hover
				border-right-color: #23282c
				border-left-color: #23282c

		.tab-content
			border: 0
			border-top: 1px solid #23282c
			border-radius: 0 0 .25rem .25rem
			background: #3a4149
			height: calc(100vh - 2.375rem - 62px) !important

			&::-webkit-scrollbar
				position: fixed
				width: 12px
				margin-left: -8px
				-webkit-appearance: none
				appearance: none

			&::-webkit-scrollbar-track
				background-color: rgba(0, 0, 0, 0.08)
				border-color: transparent

			&::-webkit-scrollbar-thumb
				background-color: rgba(0, 0, 0, 0.42)
				background-clip: content-box
				border-color: transparent
				border-radius: 5px

			.banner-tabs
				display: flex
				white-space: nowrap
				border-bottom: 1px solid #23282c
				flex-direction: row
				align-items: stretch
				width: 100%
				margin-top: 20px
				color: #73818f
				user-select: none

				.banner-tab
					border: 1px solid transparent
					border-top-left-radius: .25rem
					border-top-right-radius: .25rem
					margin-bottom: -1px
					cursor: pointer
					text-align: center
					flex: 1

				.banner-tab.active
					color: #f3f4f5
					background-color: #343b41
					border-color: #23282c #23282c #23282c

				.banner-tab:hover, .banner-tab:focus
					border-color: #23282c #23282c #23282c

			.banner-tabs-content
				margin-top: -1px
				background-color: #343b41
				border: 1px solid #23282c
				border-radius: 0 0 .25rem .25rem
				font-size: 0

				.banner-tab-content
					display: none
					padding: 16px

					.aside-settings:nth-child(2)
						margin-top: 0

				.banner-tab-content.active
					display: block

		select
			background-color: #73818f
			border-color: #73818f
			color: #fff
			margin-top: 4px
			width: auto

	html:not([dir="rtl"]) .aside-menu
		right: 0
		margin-right: -390px

</style>
